// Örnek servis codiagno login
import axios from '../javascript/custom-axios';
let RESOURCE_NAME = 'patial-price';

export default {
  add(formData) {
    return axios.post(`${RESOURCE_NAME}/add`, formData);
  },

  getPriceList(ExportImportType, ListName, page, pageSize, GetForCustomer) {
    return axios.get(`${RESOURCE_NAME}/get-price-list`, {
      params: {
        ExportImportType,
        ListName,
        page,
        pageSize,
        GetForCustomer,
      },
    });
  },

  getPriceDetail(id) {
    return axios.get(`${RESOURCE_NAME}/get-price-detail`, {
      params: {
        Id: id,
      },
    });
  },

  updatePriceExcel(body) {
    const formData = new FormData();
    formData.append('PartialPriceId', body.PartialPriceId);
    formData.append('PriceExcel', body.PriceExcel);

    return axios.put(`${RESOURCE_NAME}/update-price-excel`, formData);
  },

  updateRegionExcel(body) {
    const formData = new FormData();
    formData.append('RegionExcelId', body.RegionExcelId);
    formData.append('RegionExcel', body.RegionExcel);

    return axios.put(`${RESOURCE_NAME}/update-region-excel`, formData);
  },

  updateActivityStatus(body) {
    return axios.put(`${RESOURCE_NAME}/update-activity-status`, body);
  },

  updateExpiryDate(expiryDateData) {
    return axios.put(`${RESOURCE_NAME}/update-expiry-date`, expiryDateData);
  },

  updateName(body) {
    return axios.put(`${RESOURCE_NAME}/update-list-name`, body);
  },

  updatePriceList(body) {
    return axios.put(`${RESOURCE_NAME}/update-price-list`, body);
  },
};
